/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions, FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsFromJSONTyped, FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions';
export function FxIdDomainSettingsCompanyBrandingConfigFirebaseOptionsFromJSON(json) {
    return FxIdDomainSettingsCompanyBrandingConfigFirebaseOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsCompanyBrandingConfigFirebaseOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsCompanyBrandingConfigFirebaseOptionsToJSON(json) {
    return FxIdDomainSettingsCompanyBrandingConfigFirebaseOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsCompanyBrandingConfigFirebaseOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsCompanyBrandingConfigFirebaseOptions.js.map